import React from 'react';
import ReactDOM from 'react-dom';
import { ReactComponent as Cancel } from '../../assets/icons/cancel.svg';
import modal from '../../styles/components/modals/imageZoomModal.module.scss';

const BackDrop = ({ onConfirm }) => (
    <div className={modal.modalBackDrop} onClick={onConfirm} role="presentation" />
);

const OverlayImageModal = ({ imageURL, onConfirm }) => (
    <div className={modal.imageModal} onClick={onConfirm} role="dialog" aria-modal="true">
        <div className={modal.container} onClick={(e) => e.stopPropagation()}>
            <button type="button" className={modal.closeBtn} onClick={onConfirm} aria-label="بستن">
                <Cancel width="28px" height="28px" />
            </button>
            <div className={modal.imageWrap}>
                <img src={imageURL} alt="" className={modal.image} referrerPolicy="no-referrer" />
            </div>
        </div>
    </div>
);

const ImageModal = ({ imageURL, onConfirm }) => (
    <>
        {ReactDOM.createPortal(
            <BackDrop onConfirm={onConfirm} />,
            document.getElementById('backdrop-root')
        )}
        {ReactDOM.createPortal(
            <OverlayImageModal imageURL={imageURL} onConfirm={onConfirm} />,
            document.getElementById('overlayImageModal-root')
        )}
    </>
);

export default ImageModal;
